/** Tile, panel and empty-state chrome for the Sales insight pages. */

import type { ReactNode } from 'react'

export function Tile({
  label,
  value,
  delta,
  deltaTone,
  note,
}: {
  label: string
  value: string
  delta?: string | undefined
  deltaTone?: 'up' | 'down' | 'flat' | undefined
  note?: string | undefined
}) {
  const color =
    deltaTone === 'up'
      ? 'text-[var(--color-positive)]'
      : deltaTone === 'down'
        ? 'text-[var(--color-negative)]'
        : 'text-[var(--color-ink-muted)]'
  return (
    <div className="rounded-[var(--radius-lg)] border border-[var(--color-rule)] bg-[var(--color-surface-raised)] px-4 py-3 elevated">
      <div className="text-[length:var(--text-xs)] font-medium uppercase tracking-wide text-[var(--color-ink-muted)]">
        {label}
      </div>
      <div className="numeric mt-1 text-[length:var(--text-2xl)] font-semibold leading-tight">
        {value}
      </div>
      {delta !== undefined && (
        <div className={`numeric mt-0.5 text-[length:var(--text-sm)] ${color}`}>
          {delta}
          {note !== undefined && (
            <span className="ml-1 text-[var(--color-ink-muted)]">{note}</span>
          )}
        </div>
      )}
    </div>
  )
}

export function Panel({
  title,
  subtitle,
  children,
  wide = false,
}: {
  title: string
  subtitle?: string | undefined
  children: ReactNode
  wide?: boolean
}) {
  return (
    <section
      className={`${wide ? 'lg:col-span-12' : 'lg:col-span-6'} col-span-12 rounded-[var(--radius-lg)] border border-[var(--color-rule)] bg-[var(--color-surface-raised)] p-4 elevated`}
    >
      <h3 className="text-[length:var(--text-sm)] font-semibold">{title}</h3>
      {subtitle !== undefined && (
        <p className="mt-0.5 text-[length:var(--text-xs)] text-[var(--color-ink-muted)]">{subtitle}</p>
      )}
      <div className="mt-3">{children}</div>
    </section>
  )
}

export function Empty({ children }: { children: ReactNode }) {
  return (
    <p className="py-8 text-center text-[length:var(--text-sm)] text-[var(--color-ink-muted)]">
      {children}
    </p>
  )
}
